import Backend from "../api/Backend";
import {GifActions} from "../constants/gifActions";
import * as moment from 'moment/moment'
import {UserActionType} from "../constants/userActionType";
import gif from "../reducers/gif";
import axios from "axios";
export const onSubmit =  (user, tags, title, description, file ,text, callback) => async dispatch => {



    let metadata = {
        contentType: 'image/gif',
    };
    let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    let uniqid = randLetter + Date.now();
    let renderTags = [] ;
    let updates = {}
    tags.forEach((tag)=>{

        Backend.database().ref("tags").orderByChild("text")
            .equalTo(tag.text).once("value", snapshot => {
            let tagData
            snapshot.forEach(item =>{console.log( tagData =item.key)})

            // Check if it is a SHOP.
            if (tagData) {
                console.log("exist!");
                console.log(tagData)
                tag.id = tagData
            } else {
                console.log("not exist");
                tag.id =String.fromCharCode(65 + Math.floor(Math.random() * 26))+Date.now()
                updates[`tags/${tag.id}`] = {id:tag.id , text:tag.text}

            }
        });
    })



  let uploadTask = Backend.storage().ref(`/gifs/${uniqid}.gif`).put(file, metadata).then(
            res => {
                res.ref.getDownloadURL().then((downloadURL) => {
                    let image = {
                        id: uniqid,
                        tags: tags ,
                        title: title,
                        description: description,
                        creationDate: moment().unix(),
                        deleteDate: '',
                        URL: downloadURL,
                        ownerUserId: user.uid,
                        lastEditDate: 0,
                        deleted: false,
                        favorites:0,
                        views:0,
                        text:text || ''
                    }

                    console.log(text , 'teext')
                    try {

                       // const gifKey = Backend.database().ref(`gifs/${user.uid}`).push()

                        updates[`gifs/${uniqid}`] = image
                        updates[`user_gifs/${user.uid}/${uniqid}`] = true
                        //    updates[`users/${user.uid}/gifs/${gifKey.key}`] = true

                        Backend.database().ref().update(updates).then(
                            () => {
                                dispatch({
                                    type: GifActions.ADD_GIF,
                                    payload: {gif: {...image, key: uniqid}}
                                });
                                callback(uniqid)

                            }
                        );
                    } catch (error) {
                        console.log(error)
                        dispatch({ type: GifActions.GIF_ERROR, payload: error.message });
                    }
                })
            }
        )

};



export const addFavorite =  (user , gif , callback ) => dispatch => {
    let updates = {}
    let favorites =  user.favorites ? user.favorites : []
    favorites.push(gif.id)
    let newGif = gif
    let newUser = user
    newUser.favorites = favorites
    newGif.favorites = gif.favorites + 1
console.log(newGif.favorites)
    try {
        updates[`users/${user.uid}/favorites/${gif.id}`] = true
        updates[`gifs/${gif.id}`] =  newGif
        Backend.database().ref().update(updates).then(
            () => {
                dispatch({
                    type: GifActions.ADD_FAVORITE,
                    payload: {user: {...newUser } , gifPost : newGif}
                });
                callback()
            }
        );
    }catch (error) {
        dispatch({ type: GifActions.GIF_ERROR, payload: error.message });
        console.log(error)
    }
}

export const deleteFavorite =  (user , gif , callback ) => dispatch => {
    let updates = {}
    let favorites =  user.favorites.filter( item => gif.id !== item)
    let newUser = user
    let newGif = gif
    user.favorites = favorites
    newGif.favorites = gif.favorites - 1
console.log(newGif.favorites)
    try {
        updates[`users/${user.uid}/favorites`] = favorites
        updates[`gifs/${gif.id}`] = newGif
        Backend.database().ref().update(updates).then(
            () => {
                dispatch({
                    type: GifActions.DELETE_FAVORITE,
                    payload: {user: {...newUser} , gifPost: newGif }
                });
                callback()
            }
        );
    }catch (error) {
        dispatch({ type: GifActions.GIF_ERROR, payload: error.message });
        console.log(error)
    }
}

export const  getGif =  (gifId ,callback) => dispatch => {

    Backend.database().ref('gifs/'+gifId).once('value' ,(snapshot) =>{

            dispatch({
                type: GifActions.GET_GIF,
                payload: {gifPost: snapshot.val()}
            });
            callback()
    })


}

export const  search =  (text ,callback) => dispatch => {
    dispatch({
        type: GifActions.SEARCH,
        payload: {searchText: text}
    })

    callback()
}





// WEBPACK FOOTER //
// ./src/actions/gifAction.tsx